/** @ngInject */
export default function notificationSystemsService($http) {
  const URL_BASE = 'oc-api/operations/web-hooks';

  return {
    getNotificationSystems,
  };

  function getNotificationSystems() {
    return $http.get(URL_BASE);
  }
}



// WEBPACK FOOTER //
// ./src/app/webhooks/notificationSystems.service.js